import { SearchOutlined } from '@ant-design/icons';
import { Flex, Input, theme } from 'antd';
import { type ReactNode, useEffect, useState } from 'react';

export interface ServingToolsFiltersProps {
  onChange?: (filters: FiltersState) => void;
  initialFilters?: FiltersState;
}

interface FiltersState {
  query?: string;
}

const ServingToolsFilter = (props: ServingToolsFiltersProps): ReactNode => {
  const { initialFilters, onChange } = props;
  const [filters, setFilter] = useState<FiltersState>(initialFilters ?? {});
  const { token } = theme.useToken();

  useEffect(() => {
    onChange?.(filters);
  }, [filters]);

  return (
    <Flex gap={token.paddingXS} flex={1} wrap="wrap">
      <Input
        allowClear
        value={filters?.query}
        placeholder="Search"
        prefix={<SearchOutlined />}
        onChange={(e) => {
          setFilter((prev) => ({
            ...prev,
            query: e.target?.value || undefined,
          }));
        }}
        style={{ maxWidth: 300, marginInlineEnd: token.marginMD }}
      />
    </Flex>
  );
};

ServingToolsFilter.defaultProps = {
  onChange: (_filters: FiltersState) => {},
  initialFilters: {},
};

export default ServingToolsFilter;
